import styled from "styled-components";

export const AddModal = styled.div`
  display: flex;
  flex-direction: column;
  width: 25rem;

  .input {
    margin-bottom: 1rem;
  }

  .divider {
    margin: 1rem 0;
  }
`;
